<template>
  <div class="page__shopee-marketing a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <el-row style="margin-bottom: 10px">
        <el-col :sm="12" style="display: flex; gap: 20px">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"></shop-select>
        </el-col>
      </el-row>

      <div style="margin-top: 50px">
        <div style="display: flex">
          <div style="flex: 1; display: flex; gap: 10px">
            <div style="width: 200px; max-width: 200px">
              <strong class="strong-label">Campaign ID:</strong>
              <el-input v-model="campaign_id" :placeholder="$t('input.campaign_id')" size="mini"></el-input>
            </div>
            <div style="width: 250px; max-width: 250px">
              <strong class="strong-label">{{ $t('base.duration') }}:</strong>
              <el-date-picker
                class="full-w" v-model="date_range" type="daterange" range-separator="-"
                :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
                format="dd-MM-yyyy"
                :clearable="false" :picker-options="picker_options">
              </el-date-picker>
            </div>
            <div style="width: 200px; max-width: 200px">
              <strong class="strong-label">{{ $t('base.level') }}:</strong>
              <el-select v-model="target" size="mini" class="full-w" value="">
                <el-option :label="$t('base.all_data')" value=""></el-option>
                <el-option :label="$t('base.campaign')" value="campaign"></el-option>
                <el-option :label="$t('base.keyword')" value="keyword"></el-option>
                <el-option :label="$t('base.discovery_placement')" value="placement"></el-option>
              </el-select>
            </div>
            <div v-if="target === 'keyword'" style="width: 200px; max-width: 200px">
              <strong class="strong-label">{{ $t('base.keyword') }}:</strong>
              <el-input v-model="keyword" size="mini" :placeholder="$t('input.keyword')" clearable></el-input>
            </div>
            <div v-if="target === 'placement'" style="width: 200px; max-width: 200px">
              <strong class="strong-label">{{ $t('base.discovery_placement') }}:</strong>
              <el-select v-model="placement" size="mini" class="full-w" value="">
                <el-option :label="$t('base.all_placements')" value=""></el-option>
                <el-option :label="$t('base.daily_discover')" :value="2"></el-option>
                <el-option :label="$t('base.you_may_also_like')" :value="5"></el-option>
              </el-select>
            </div>
            <div style="width: 200px; max-width: 200px">
              <strong class="strong-label">&nbsp;</strong>
              <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading.get_data"
                         @click="m__get_data()">
                {{ $t('base.lookup') }}
              </el-button>
            </div>
          </div>
        </div>

        <div style="margin-top: 30px">
          <el-table :data="c__data_display_list">
            <el-table-column label="Campaign ID" width="110px">
              <template slot-scope="scope">
                {{ scope.row.campaign_id }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.audience')" width="200px" show-tooltip-when-overflow>
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('base.click_to_view_detail')" placement="top-start">
                  <div @click="m__open_new_view(scope.row)">
                    <div>
                      {{ m__map_target(scope.row) }}
                    </div>
                    <div v-if="scope.row.target === 'keyword'">
                      <strong style="font-size: 12px">{{ scope.row.keyword }}</strong>
                    </div>
                    <div v-if="scope.row.target === 'placement'">
                      <strong v-if="scope.row.placement === 2" style="font-size: 12px">{{
                          $t('base.daily_discover')
                        }}</strong>
                      <strong v-if="scope.row.placement === 5" style="font-size: 12px">{{
                          $t('base.you_may_also_like')
                        }}</strong>
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.timestamp')">
              <template slot-scope="scope">
                {{ scope.row.created_time | moment('DD-MM-YYYY HH:mm') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.config')" show-tooltip-when-overflow>
              <template slot-scope="scope">
                {{ scope.row.config_name || '-' }}
                <br>
                {{ $t('base.note') }}: {{ scope.row.note || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.conditions')" show-tooltip-when-overflow>
              <template slot-scope="scope">
                {{
                  scope.row.eval_string ? scope.row.eval_string.replace(/(\d+\.\d{2})\d+/g, '$1').replace(/&&/ig, $t('base.and')).replace(/\|\|/ig, $t('base.or')) : ''
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')">
              <template slot-scope="scope">
                {{ m__map_action(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.old_data')">
              <template slot-scope="scope">
                {{ m__map_old_data(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.new_data')">
              <template slot-scope="scope">
                {{ m__map_new_data(scope.row) }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page.sync="data_filter.current_page" :page-size="data_filter.page_size"
                         layout="prev, pager, next, total" :total="c__data_filter_list.length"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {picker_options} from "../../../addon/options";
import {drop as _drop, take as _take} from "lodash";
import {get_shop_mixins} from "../../../mixins/get_shop";

export default {
  mixins: [
    get_shop_mixins
  ],

  data() {
    return {
      picker_options,

      loading: {
        get_data: false
      },
      show_dialog: {},

      campaign_id: null,
      target: '',
      keyword: '',
      placement: '',
      date_range: [new Date(), new Date()],

      data: [],
      data_filter: {
        page_size: 30,
        current_page: 0,
        keyword: '',
      },
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()

    const {
      campaign_id,
      target,
      keyword,
      placement,
      start_time,
      end_time
    } = this.$route.query
    if (campaign_id) {
      this.campaign_id = campaign_id
    }
    if (target) {
      this.target = target
    }
    if (this.target === 'keyword') {
      this.keyword = keyword
    }
    if (this.target === 'placement') {
      this.placement = placement
    }
    if (start_time && end_time) {
      this.date_range = [new Date(+start_time * 1000), new Date(+end_time * 1000)]
    }

    if (this.shop && this.shop.shop_id && campaign_id) {
      await this.m__get_data()
    }
  },

  computed: {
    c__data_filter_list() {
      return this.data
    },

    c__data_display_list() {
      const limit = this.data_filter.page_size
      const skip = limit * (this.data_filter.current_page - 1)

      return _take(_drop(this.c__data_filter_list, skip), limit)
    }
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  methods: {
    m__open_new_view(data) {
      let url = `/marketing/log/auto_condition?shop_id=${this.shop.shop_id}&campaign_id=${data.campaign_id}&target=${data.target}&start_time=${this.dayjs(this.date_range[0]).startOf('day').unix()}&end_time=${this.dayjs(this.date_range[1]).endOf('day').unix()}`
      if (data.target === 'keyword') {
        url += `&keyword=${data.keyword}`
      }
      if (data.target === 'placement') {
        url += `&placement=${data.placement}`
      }

      window.open(url, '_blank')
    },

    m__map_target(data) {
      if (data.target === 'campaign') return this.$t('base.campaign')
      if (data.target === 'keyword') return this.$t('base.keyword')
      if (data.target === 'placement') return this.$t('base.discovery_placement')

      return data.target
    },

    m__map_action(data) {
      if (data.target === 'campaign') {
        if (data.action === 'increase') return this.$t('base.increase_budget')
        if (data.action === 'reduce') return this.$t('base.decrease_budget')
        if (data.action === 'value') return this.$t('base.set_budget')
        if (data.action === 'ongoing') return this.$t('base.resume_campaign')
        if (data.action === 'pause') return this.$t('base.pause_campaign')
        if (data.action === 'set_by_cost') return this.$t('base.set_budget_by_realtime_cost')
        if (data.action === 'clone') return this.$t('base.clone_campaign')
      }

      if (data.target === 'keyword') {
        if (data.action === 'increase') return this.$t('base.increase_bid_price')
        if (data.action === 'reduce') return this.$t('base.decrease_bid_price')
        if (data.action === 'value') return this.$t('base.set_bid_price')
        if (data.action === 'ongoing') return this.$t('base.resume_keyword')
        if (data.action === 'pause') return this.$t('base.pause_keyword')
        if (data.action === 'match_type_0') return this.$t('base.change_to_exact')
        if (data.action === 'match_type_1') return this.$t('base.change_to_broad')
        if (data.action === 'start') return this.$t('base.use_starting_bid_price')
        if (data.action === 'cpc') return this.$t('base.set_by_cpc')
      }

      if (data.target === 'placement') {
        if (data.action === 'increase') return this.$t('base.increase_bid_price')
        if (data.action === 'reduce') return this.$t('base.decrease_bid_price')
        if (data.action === 'value') return this.$t('base.set_bid_price')
        if (data.action === 'ongoing') return 'Bật quảng cáo'
        if (data.action === 'pause') return 'Tạm dừng quảng cáo'
        if (data.action === 'start') return this.$t('base.use_starting_bid_price')
        if (data.action === 'cpc') return this.$t('base.set_by_cpc')
      }

      return data.action
    },

    m__map_old_data(data) {
      if (data.target === 'campaign') {
        if (data.action === 'increase') return this.format_currency(data.old_daily_quota)
        if (data.action === 'reduce') return this.format_currency(data.old_daily_quota)
        if (data.action === 'value') return this.format_currency(data.old_daily_quota)
        if (data.action === 'set_by_cost') return this.format_currency(data.old_daily_quota)
        if (data.action === 'ongoing') {
          if (data.old_state === 'paused') return this.$t('base.paused')
          if (data.old_state === 'ongoing') return this.$t('base.ongoing')
          if (data.old_state === 'ended') return this.$t('base.ended')
        }
        if (data.action === 'pause') {
          if (data.old_state === 'paused') return this.$t('base.paused')
          if (data.old_state === 'ongoing') return this.$t('base.ongoing')
          if (data.old_state === 'ended') return this.$t('base.ended')
        }
      }

      if (data.target === 'keyword') {
        if (data.action === 'increase') return this.format_currency(data.old_price)
        if (data.action === 'reduce') return this.format_currency(data.old_price)
        if (data.action === 'value') return this.format_currency(data.old_price)
        if (data.action === 'ongoing') {
          if (data.old_status === 1) return this.$t('base.ongoing')
          if (data.old_status === 0) return this.$t('base.paused')
          if (data.old_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'pause') {
          if (data.old_status === 1) return this.$t('base.ongoing')
          if (data.old_status === 0) return this.$t('base.paused')
          if (data.old_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'match_type_0') return this.format_currency(data.old_price)
        if (data.action === 'match_type_1') return this.format_currency(data.old_price)
        if (data.action === 'start') return this.format_currency(data.old_price)
        if (data.action === 'cpc') return this.format_currency(data.old_price)
      }

      if (data.target === 'placement') {
        if (data.action === 'increase') return this.format_currency(data.old_price)
        if (data.action === 'reduce') return this.format_currency(data.old_price)
        if (data.action === 'value') return this.format_currency(data.old_price)
        if (data.action === 'start') return this.format_currency(data.old_price)
        if (data.action === 'ongoing') {
          if (data.old_status === 1) return this.$t('base.ongoing')
          if (data.old_status === 0) return this.$t('base.paused')
          if (data.old_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'pause') {
          if (data.old_status === 1) return this.$t('base.ongoing')
          if (data.old_status === 0) return this.$t('base.paused')
          if (data.old_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'cpc') return this.format_currency(data.old_price)
      }
    },

    m__map_new_data(data) {
      if (data.target === 'campaign') {
        if (data.action === 'increase') return this.format_currency(data.new_daily_quota)
        if (data.action === 'reduce') return this.format_currency(data.new_daily_quota)
        if (data.action === 'value') return this.format_currency(data.new_daily_quota)
        if (data.action === 'set_by_cost') return this.format_currency(data.new_daily_quota)
        if (data.action === 'ongoing') {
          if (data.new_state === 'paused') return this.$t('base.paused')
          if (data.new_state === 'ongoing') return this.$t('base.ongoing')
          if (data.new_state === 'ended') return this.$t('base.ended')
        }
        if (data.action === 'pause') {
          if (data.new_state === 'paused') return this.$t('base.paused')
          if (data.new_state === 'ongoing') return this.$t('base.ongoing')
          if (data.new_state === 'ended') return this.$t('base.ended')
        }
      }

      if (data.target === 'keyword') {
        if (data.action === 'increase') return this.format_currency(data.new_price)
        if (data.action === 'reduce') return this.format_currency(data.new_price)
        if (data.action === 'value') return this.format_currency(data.new_price)
        if (data.action === 'ongoing') {
          if (data.new_status === 1) return this.$t('base.ongoing')
          if (data.new_status === 0) return this.$t('base.paused')
          if (data.new_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'pause') {
          if (data.new_status === 1) return this.$t('base.ongoing')
          if (data.new_status === 0) return this.$t('base.paused')
          if (data.new_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'match_type_0') return this.format_currency(data.new_price)
        if (data.action === 'match_type_1') return this.format_currency(data.new_price)
        if (data.action === 'start') return this.format_currency(data.new_price)
        if (data.action === 'cpc') return this.format_currency(data.new_price)
      }

      if (data.target === 'placement') {
        if (data.action === 'increase') return this.format_currency(data.new_price)
        if (data.action === 'reduce') return this.format_currency(data.new_price)
        if (data.action === 'value') return this.format_currency(data.new_price)
        if (data.action === 'start') return this.format_currency(data.new_price)
        if (data.action === 'ongoing') {
          if (data.old_status === 1) return this.$t('base.ongoing')
          if (data.old_status === 0) return this.$t('base.paused')
          if (data.old_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'pause') {
          if (data.old_status === 1) return this.$t('base.ongoing')
          if (data.old_status === 0) return this.$t('base.paused')
          if (data.old_status === 3) return this.$t('base.paused')
        }
        if (data.action === 'cpc') return this.format_currency(data.new_price)
      }
    },

    async m__initial_view() {
      try {
        const shop = this.shopee_shop.list.find(i => i._id === this.shopee_shop.selected)
        if (!shop) return

        // todo: check role
        if (!this.check_role(shop, 'marketing', 'campaigns')) {
          this.shopee_shop.selected = ''
          return
        }

        this.shop = shop
        this.sp_user = await this.init_seller(this.shop)

        if (!await this.check_shop(this.sp_user)) {
          this.shopee_shop.selected = ''
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('shop.connect_error'))
      }
    },

    async m__get_data() {
      if (!this.campaign_id) return this.ntf_e(this.$t('required.campaign_id'))

      this.data = []
      this.data_filter.current_page = 0

      this.loading.get_data = true
      try {
        const form = {
          shop_id: this.shop._id,
          campaign_id: this.campaign_id,
          start_time: this.dayjs(this.date_range[0]).startOf('day').unix(),
          end_time: this.dayjs(this.date_range[1]).endOf('day').unix(),
          target: this.target,
          keyword: this.keyword,
          placement: this.placement
        }

        if (!this.target || this.target === 'campaign') {
          form.placement = null
          form.keyword = null
        }
        if (this.target === 'keyword') {
          form.placement = null
        }
        if (this.target === 'placement') {
          form.keyword = null
        }

        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/auto_condition_action/get_log', form, this.cf())
        this.data = response.body.data
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/log/auto_condition_action.vue